// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1612":"16cd3fa2ecc1d565","7901":"5bc35bde0a28fb13"}[chunkId] + ".js";
};